import { Fragment, useCallback, useState } from 'react';
import Input from '../../../form/Input';
import { getDiscountRate } from '../../../../util/util';

interface PDiscountProps {
  pRef: React.RefObject<HTMLInputElement>;
  pCost: string;
  value?: string;
  onChange?: (value: string) => void;
}

/**
 * @author taulmax
 * @date 2024.10.30
 * @description 상품 등록 페이지 - 상품 할인 금액
 */
const PDiscount = ({
  pRef,
  pCost,
  value: externalValue,
  onChange: externalOnChange,
}: PDiscountProps) => {
  const [internalValue, setInternalValue] = useState<string>('');
  const value = externalValue !== undefined ? externalValue : internalValue;
  
  const onChangePDiscount = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const rawValue = e.target.value.replace(/[^0-9]/g, ''); // 숫자 이외의 문자 제거
      let formattedValue = '';
      if (rawValue !== '') {
        formattedValue = Number(rawValue).toLocaleString(); // 천단위 콤마 추가
      }
      
      if (externalOnChange) {
        externalOnChange(formattedValue);
      } else {
        setInternalValue(formattedValue);
      }
    },
    [externalOnChange]
  );

  return (
    <div>
      <span style={{ fontSize: '13px', color: '#6b7280', marginBottom: '4px', display: 'block' }}>할인 가격</span>
      <Input
        inputRef={pRef}
        value={value}
        onChange={onChangePDiscount}
        textAlign="left"
        placeholder="할인 적용가 입력"
        suffix="₩"
        style={{ width: '100%' }}
      />
      {value && (
        <span style={{ fontSize: '12px', color: '#ff6b6b', marginTop: '4px', display: 'block' }}>
          할인율: {getDiscountRate(value, pCost)}%
        </span>
      )}
    </div>
  );
};

export default PDiscount;
